module.exports = __webpack_public_path__ + "img/Flag_of_Namibia.c9720b4a.svg";